import { CalibrationFrequency } from "../enums/calibrationFrequency.enum";

export class DeviceCalibrationHistory {
    id: string;
    sensorId: string;
    sensorName: string;
    calibrationDate: number | string | Date;
    nextCalibrationDate: number | string | Date;
    calibrationStatus: boolean;
    certificateFileName: string;
    certificateUrl: string;
    calibrationEquipmentId: string;
    calibrationFrequency?: CalibrationFrequency;
}